import * as React from 'react'
import { __DEV__ } from '@mote/helpers/constants'
import { forwardRef } from '../../system'
import type { IconProps } from './icon'
import { Icon } from './icon'

interface CreateIconOptions {
  viewBox?: string
  path?: React.ReactElement | React.ReactElement[]
  d?: string
  displayName?: string
  defaultProps?: IconProps
}

export function createIcon(options: CreateIconOptions) {
  const {
    viewBox = '0 0 24 24',
    d: pathDefinition,
    displayName,
    defaultProps = {}
  } = options
  const path = React.Children.toArray(options.path)

  const Comp = forwardRef<IconProps, 'svg'>((props, ref) => (
    <Icon ref={ref} viewBox={viewBox} {...defaultProps} {...props}>
      {path.length ? path : <path fill='currentColor' d={pathDefinition} />}
    </Icon>
  ))

  if (__DEV__) {
    Comp.displayName = displayName
  }

  return Comp
}
